import * as React from "react";

function SvgFileUpload(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.414 1H5a2 2 0 00-2 2v18a2 2 0 002 2h14a2 2 0 002-2V6.586L15.414 1zM5 3h8v4a2 2 0 002 2h4v12H5V3zm10 4V3.414L18.586 7H15zm-2 11v-4.586l1.293 1.293 1.414-1.414L12 9.586l-3.707 3.707 1.414 1.414L11 13.414V18h2z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgFileUpload;
